import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Sofía M.',
  place: 'Mendoza',
  product: 'COCINA RESUELTA + POSTRES'
}, {
  name: 'Martín G.',
  place: 'Mar del Plata',
  product: 'COCINA RESUELTA COMPLETO'
}, {
  name: 'Carla R.',
  place: 'Salta',
  product: 'COCINA RESUELTA + POSTRES'
}, {
  name: 'Diego F.',
  place: 'Neuquén',
  product: 'COCINA RESUELTA COMPLETO'
}, {
  name: 'Valeria S.',
  place: 'Tucumán',
  product: 'COCINA RESUELTA + POSTRES'
}, {
  name: 'Lucía P.',
  place: 'La Plata',
  product: 'COCINA RESUELTA COMPLETO'
}, {
  name: 'Javier A.',
  place: 'Rosario',
  product: 'COCINA RESUELTA + POSTRES'
}, {
  name: 'Romina T.',
  place: 'Córdoba',
  product: 'COCINA RESUELTA COMPLETO'
}, {
  name: 'Nahuel B.',
  place: 'San Juan',
  product: 'COCINA RESUELTA + POSTRES'
}, {
  name: 'Florencia D.',
  place: 'Bahía Blanca',
  product: 'COCINA RESUELTA COMPLETO'
}];
const timeLabels = ['Hace unos segundos', 'Hace 1 minuto', 'Hace 2 minutos', 'Hace 4 minutos'];
export const SalesPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [time, setTime] = useState(timeLabels[0]);
  useEffect(() => {
    let i = 0;
    const show = () => {
      setIndex(Math.floor(Math.random() * purchases.length));
      setTime(timeLabels[Math.floor(Math.random() * timeLabels.length)]);
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 6000);
    };
    const firstTimer = setTimeout(show, 4000);
    const interval = setInterval(() => {
      i += 1;
      show();
    }, 16000);
    return () => {
      clearTimeout(firstTimer);
      clearInterval(interval);
    };
  }, []);
  const purchase = purchases[index];
  return <AnimatePresence data-id="element-17">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} role="status" aria-live="polite" className="fixed bottom-4 left-4 z-50 bg-black border-2 border-orange-500 rounded-lg p-4 shadow-[0_0_25px_rgba(249,115,22,0.6)] max-w-[300px] flex items-start gap-3" data-id="element-18">
          <CheckCircle className="text-orange-500 w-8 h-8 flex-shrink-0 mt-1" data-id="element-19" />
          <div data-id="element-20">
            <p className="text-[11px] text-orange-400 uppercase tracking-wider font-bold mb-1" data-id="element-21">
              ✅ Alguien acaba de comprar
            </p>
            <p className="font-bold text-white text-sm leading-tight" data-id="element-22">
              {purchase.product}
            </p>
            <p className="text-xs text-orange-400 mt-2 font-medium" data-id="element-23">
              {purchase.name} — {purchase.place}, Argentina
            </p>
            <p className="text-[11px] text-gray-500 mt-1" data-id="element-24">{time}</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};